"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

interface SearchItem {
  name: string;
  category: "Tools" | "Nakshatras" | "Yogas & Doshas" | "Panchang";
  href: string;
  icon: string;
  hindi?: string;
}

const SEARCH_DIRECTORY: SearchItem[] = [
  {
    name: "Free Janam Kundali",
    category: "Tools",
    href: "/free-kundali/",
    icon: "🔮",
    hindi: "मुफ्त जन्म कुंडली",
  },
  {
    name: "Kundli Matching & Milan",
    category: "Tools",
    href: "/kundli-matching/",
    icon: "💍",
    hindi: "कुंडली मिलान",
  },
  {
    name: "Daily Panchang Today",
    category: "Panchang",
    href: "/panchang/",
    icon: "📅",
    hindi: "आज का पंचांग",
  },
  {
    name: "Aaj Ka Choghadiya",
    category: "Panchang",
    href: "/choghadiya/",
    icon: "⏰",
    hindi: "चौघड़िया मुहूर्त",
  },
  {
    name: "Rahu Kaal Timings",
    category: "Panchang",
    href: "/rahu-kaal/",
    icon: "⏳",
    hindi: "राहु काल",
  },
  {
    name: "Shubh Muhurat Today",
    category: "Panchang",
    href: "/shubh-muhurat/",
    icon: "✨",
    hindi: "शुभ मुहूर्त",
  },
  {
    name: "Raj Yoga Calculator",
    category: "Yogas & Doshas",
    href: "/raj-yoga-calculator/",
    icon: "👑",
    hindi: "राज योग",
  },
  {
    name: "Dhana Yoga Calculator",
    category: "Yogas & Doshas",
    href: "/dhana-yoga-calculator/",
    icon: "💰",
    hindi: "धन योग",
  },
  {
    name: "Foreign Settlement (Videsh Yatra)",
    category: "Yogas & Doshas",
    href: "/videsh-yatra-yoga/",
    icon: "✈️",
    hindi: "विदेश यात्रा योग",
  },
  {
    name: "Government Job Yoga",
    category: "Yogas & Doshas",
    href: "/government-job-yoga/",
    icon: "🏛️",
    hindi: "सरकारी नौकरी योग",
  },
  {
    name: "Love Marriage Yoga",
    category: "Yogas & Doshas",
    href: "/love-marriage-yoga/",
    icon: "💖",
    hindi: "प्रेम विवाह योग",
  },
  {
    name: "Sade Sati Calculator",
    category: "Yogas & Doshas",
    href: "/sade-sati/",
    icon: "🪐",
    hindi: "साढ़े साती",
  },
  {
    name: "Kaal Sarp Dosha",
    category: "Yogas & Doshas",
    href: "/kaal-sarp-dosha/",
    icon: "🐍",
    hindi: "काल सर्प दोष",
  },
  {
    name: "Manglik Dosha Calculator",
    category: "Yogas & Doshas",
    href: "/mangal-dosha-calculator/",
    icon: "🔥",
    hindi: "मांगलिक दोष",
  },
  {
    name: "27 Nakshatras Directory",
    category: "Nakshatras",
    href: "/nakshatra/",
    icon: "🌟",
    hindi: "27 नक्षत्र",
  },
  {
    name: "Ashwini Nakshatra",
    category: "Nakshatras",
    href: "/nakshatra/ashwini/",
    icon: "🐴",
    hindi: "अश्विनी",
  },
  {
    name: "Rohini Nakshatra",
    category: "Nakshatras",
    href: "/nakshatra/rohini/",
    icon: "🌸",
    hindi: "रोहिणी",
  },
  {
    name: "Pushya Nakshatra",
    category: "Nakshatras",
    href: "/nakshatra/pushya/",
    icon: "🌺",
    hindi: "पुष्य",
  },
  {
    name: "Magha Nakshatra",
    category: "Nakshatras",
    href: "/nakshatra/magha/",
    icon: "🦁",
    hindi: "मघा",
  },
  {
    name: "Revati Nakshatra",
    category: "Nakshatras",
    href: "/nakshatra/revati/",
    icon: "🐟",
    hindi: "रेवती",
  },
  {
    name: "Navamsha D9 Chart",
    category: "Tools",
    href: "/navamsa-chart/",
    icon: "📊",
    hindi: "नवांश कुंडली",
  },
  {
    name: "Dasamsa D10 Chart",
    category: "Tools",
    href: "/dasamsa/",
    icon: "💼",
    hindi: "दशांश कुंडली",
  },
  {
    name: "Vimshottari Dasha",
    category: "Tools",
    href: "/dasha-calculator/",
    icon: "⏳",
    hindi: "दशा कैलकुलेटर",
  },
  {
    name: "Talk to AI Astrologer",
    category: "Tools",
    href: "/talk-to-astrologer/",
    icon: "🤖",
    hindi: "ज्योतिषी से बात करें",
  },
];

export default function GlobalCommandPalette() {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const router = useRouter();

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setIsOpen((prev) => !prev);
      }
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const filtered =
    query.trim() === ""
      ? SEARCH_DIRECTORY.slice(0, 10)
      : SEARCH_DIRECTORY.filter(
          (item) =>
            item.name.toLowerCase().includes(query.toLowerCase()) ||
            (item.hindi && item.hindi.includes(query)) ||
            item.category.toLowerCase().includes(query.toLowerCase())
        );

  const handleSelect = (href: string) => {
    setIsOpen(false);
    setQuery("");
    router.push(href);
  };

  return (
    <>
      {/* Search trigger button in header */}
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="inline-flex items-center gap-1.5 rounded-lg border border-border-default bg-surface-muted px-2.5 py-1.5 text-caption text-text-secondary hover:border-border-interactive hover:text-text-primary transition"
        aria-label="Quick search (⌘K)"
      >
        <span className="text-body-small">🔍</span>
        <span className="hidden sm:inline font-medium">Search tools...</span>
        <kbd className="hidden sm:inline-block rounded border border-border-default bg-surface-primary px-1.5 py-0.5 text-caption font-mono text-text-muted">
          ⌘K
        </kbd>
      </button>

      {/* Modal Overlay */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 p-4 pt-16 sm:pt-24 backdrop-blur-xs">
          <div
            className="w-full max-w-lg rounded-2xl border border-border-interactive bg-surface-primary shadow-2xl overflow-hidden"
            data-design-owner="command-palette"
          >
            {/* Search Input Bar */}
            <div className="flex items-center border-b border-border-default px-4 py-3">
              <span className="text-lg mr-2.5 text-text-muted">🔍</span>
              <input
                type="text"
                autoFocus
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search tools, yogas, nakshatras, panchang... (e.g. Raj Yoga, Pushya)"
                className="w-full bg-transparent text-body font-medium text-text-primary outline-none placeholder:text-text-muted"
              />
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="rounded-md p-1 text-text-muted hover:bg-surface-muted hover:text-text-primary text-caption"
              >
                ESC
              </button>
            </div>

            {/* Results List */}
            <div className="max-h-80 overflow-y-auto p-2 space-y-1 divide-y divide-border-subtle">
              {filtered.length === 0 ? (
                <div className="py-8 text-center text-body-small text-text-muted">
                  No matching tools found for &quot;{query}&quot;
                </div>
              ) : (
                filtered.map((item) => (
                  <button
                    key={item.href}
                    type="button"
                    onClick={() => handleSelect(item.href)}
                    className="w-full flex items-center justify-between px-3 py-2.5 rounded-xl text-left hover:bg-surface-brand-subtle transition group"
                  >
                    <div className="flex items-center gap-3">
                      <span className="text-xl shrink-0">{item.icon}</span>
                      <div>
                        <div className="text-body-small font-semibold text-text-primary group-hover:text-intent-brand transition">
                          {item.name}
                        </div>
                        {item.hindi && (
                          <div className="text-caption text-text-muted">{item.hindi}</div>
                        )}
                      </div>
                    </div>
                    <span className="text-caption rounded-md bg-surface-muted px-2 py-0.5 font-medium text-text-secondary">
                      {item.category}
                    </span>
                  </button>
                ))
              )}
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between border-t border-border-default bg-surface-muted px-4 py-2 text-caption text-text-muted">
              <span>Quick Navigation</span>
              <span>
                Press <kbd className="font-mono">ESC</kbd> to close
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
